import React from "react";
import { Button } from "@fluentui/react-components";
import { ArrowCollapseAll20Regular, ArrowExpandAll20Regular } from "@fluentui/react-icons";
import { OutlineControlsMode } from "./OutlineControlsMode";
import { OutlineControlsNonMode } from "./OutlineControlsNonMode";
import "./OutlineControls.css";

import type { OutlineControlsModeProps } from "./OutlineControlsMode";
import type { OutlineControlsNonModeProps } from "./OutlineControlsNonMode";

export interface OutlineControlsProps
  extends OutlineControlsModeProps, OutlineControlsNonModeProps {}

export function OutlineControls(props: React.PropsWithChildren<OutlineControlsProps>) {
  const handleExpandAll = () => {
    if (!props.expandAll) {
      props.onExpandAll();
    } else {
      props.onCollapseAll();
    }
  };

  return (
    <div className="outline-controls">
      <div className="outline-controls-main">
        <OutlineControlsMode outlineMode={props.outlineMode} onSelectOutlineMode={props.onSelectOutlineMode} />
        <OutlineControlsNonMode
          outlineSortMode={props.outlineSortMode}
          expandAll={props.expandAll}
          outlineMode={props.outlineMode}
          onCollapseAll={props.onCollapseAll}
          onExpandAll={props.onExpandAll}
          onSelectOutlineSortMode={props.onSelectOutlineSortMode}
        />
      </div>
      <Button
        className="outline-controls-expand"
        appearance="transparent"
        icon={props.expandAll ? <ArrowCollapseAll20Regular /> : <ArrowExpandAll20Regular />}
        onClick={handleExpandAll}
      />
    </div>
  );
}
